<script lang="ts" setup>
import type { Field } from '@haskoning/vue-component-library'

type RadioGroupProps = {
	modelValue: Record<string, any>
	field: Field
	rules?: Array<(value: any) => string | true>
}

const { modelValue, field, rules = [] } = defineProps<RadioGroupProps>()

const emit = defineEmits<{
	(e: 'update:modelValue', value: any): void
	(e: 'update'): any
}>()

const internalValue = computed({
	get: () => modelValue[field.parameter],
	set: (value: any) => {
		modelValue[field.parameter] = value
		emit('update:modelValue', modelValue)
		emit('update')
	}
})
</script>
<template>
	<v-radio-group
		:key="field.parameter"
		:readonly="field.read_only"
		v-model="internalValue"
		:v-bind="$attrs"
	>
		<v-radio
			class="flex-grow-1"
			v-for="choice in field.choices"
			:key="choice.value"
			:label="choice.display_name"
			:value="choice.value"
			color="primary"
		/>
	</v-radio-group>
</template>
